<template>
  <div>
    <TopNavigation activeApp="IP Manager"/>

    <b-container fluid class="app-nav ml-0">
      <b-row align-h="text-right">
        <b-col class="my-1" style="text-align:left">
          <b-form-group
            label="Items/page"
            label-cols="3"
            label-align="left"
            label-size="sm"
            label-for="perPageSelect"
            class="m-0"
          >
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
              style="align-items:left;width:25%"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="5" class="my-1" style="text-align:center">
          <b-form-group
            label="Filter"
            label-cols-sm="1"
            label-align-sm="center"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="my-1">
          <b-button 
            size="sm" 
            variant="outline-secondary"
            @click="addNew($event.target)"
          > Add New Network</b-button>
        </b-col>
      </b-row>
    </b-container>

    <b-table
      stacked="sm"
      ref="networkTable"
      fixed
      show-empty 
      small 
      hover 
      striped 
      bordered 
      :filter="filter"
      @filtered="onFiltered"
      :busy="isBusy"
      :items="items" 
      :fields="fields" 
      :current-page="currentPage"
      :per-page="perPage"
      sticky-header="500px"
      no-border-collapse
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      selectable
      select-mode="single"
      selected-variant="success"
      @row-selected="onNetworkSelected"
      style="word-break: break-all"
    >

      <div slot="table-busy" class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
      </div>
   </b-table>

    <IPManNetwork v-if="showItem" :guid="selectedGuid" v-on:cancelled="resetSelected" v-on:updated="networkUpdated" />


      <!--template v-slot:cell(actions)="row">
        <b-button size="sm" variant="outline-secondary" @click="edit(row.item, row.index, $event.target)" class="mr-1">
          Edit
        </b-button>
        <b-button size="sm" variant="outline-danger" @click="deleteNetwork(row.item, row.index, $event.target)" class="mr-1">
          Delete
        </b-button>
      </template-->

 
    <!-- New modal -->
    <!--b-modal :id="newModal.id" :title="newModal.title" @hide="resetNewModal" hide-footer>
      <IPManNetwork action="createNW" v-on:complete="newComplete" v-on:cancelled="newCancelled"/>
    </b-modal-->


    <!-- Edit modal -->
    <!--b-modal :id="editModal.id" :title="editModal.title" hide-footer @hide="resetEditModal">
      <IPManNetwork action="editNW" :network="selectedNetwork" v-on:complete="editComplete" v-on:cancelled="editCancelled"/>
    </b-modal-->


    <!-- Delete modal -->
    <!--b-modal :id="deleteModal.id" :title="deleteModal.title" hide-footer @hide="resetDeleteModal">
      <IPManNetwork action="deleteNW" :network="selectedNetwork" v-on:complete="deleteComplete" v-on:cancelled="deleteCancelled"/>
    </b-modal-->

    <b-container class="app-nav mr-0">
      <b-row align-h="end">
        <b-col cols="3">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-2"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>

  <!--div v-on:click="getAllNetworks">Click here for getall networks api call</div>
  <div v-on:click="getNetwork">Click here for getnetwork api call</div-->


  </div>
</template>

<script>
import IPManNetwork from '@/components/ipman/Ipmannetwork.vue'
import IPManService from '@/api-services/ipman.service'
import TopNavigation from '@/components/TopNavigation.vue'
import { Auth } from 'aws-amplify'

export default {
  name: 'ipmanlist',
  components: {
    IPManNetwork,
    TopNavigation
  },
  data() {
    return {
      sortBy: 'name.S',
      sortDesc: false,
      fields: [
        {
          key: 'name.S',
          label: 'Name',
          sortable: true
        },
        {
          key: 'description.S',
          label: 'Description',
          sortable: true
        },
        {
          key: 'network_type.S',
          label: 'Network Type',
          sortable: true
        },
        {
          key: 'organisation.S',
          label: 'Organisation',
          sortable: true,
        },
      ],
      items:[],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 30, 50],
      filter: null,
      filterOn: [],
      showItem:false,
      selectedItem:[],
      isBusy: false,
      selectedGuid:null,
    }
  },
  mounted() {
      // Set the initial number of items
      this.getAllNetworks()
      this.totalRows = this.items.length
  },
  methods: {
    onNetworkSelected(items) {
      console.log(items)
      if (items.length!=0){ //required as this.$refs.networkTable.clearSelected() triggers @row-selected in order to deselct
        this.selectedGuid = items[0].guid
        this.showItem = true
      }
    },
    resetSelected(){
      this.showItem = false
      this.$refs.networkTable.clearSelected()
      this.selectedGuid = null
    },
    addNew() {
      this.showItem = true
    },
    networksUpdated(){
      this.showItem = false
      this.selectedGuid = null
      this.getAllNetworks()
    },
    getAllNetworks() {
      this.isBusy = true
      let promise = IPManService.getAllNetworks()
      return promise.then((data) => {
        console.log(data)
        this.items = data.Items
        // Here we could override the busy state, setting isBusy to false
        this.isBusy = false
        this.totalRows = this.items.length
      }).catch(error => {

        console.log(JSON.stringify(error.response.data.message))        
        if (error.response.status == '403'){
          this.$router.push({ path: '/auth'})
        }

        // Here we could override the busy state, setting isBusy to false
        console.log(JSON.stringify(error.response.status))        


        if (error.response.data.error){
          console.log(error.response.data.error)
          console.log("error.response.data.error")
        } else if (error.message){
          console.log(error.message)
          console.log("error.message")
        } else {
          console.log(JSON.stringify(error))        
          console.log("error")
        }

        this.items=[]
        this.isBusy = false
        this.totalRows = this.items.length
      })               
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    // edit(item, index, button) {
    //   //this.editModal.title = `Row index: ${index}`
    //   //this.editModal.content = JSON.stringify(item, null, 2)

    //   this.editModal.title = `Edit Network: ${item.name.S}`
    //   this.selectedNetwork=item
    //   this.$root.$emit('bv::show::modal', this.editModal.id, button)
    // },
    // resetEditModal() {
    //   this.editModal.title = ''
    //   this.editModal.content = ''
    // },
    // editComplete(){
    //   this.$root.$emit('bv::hide::modal', this.editModal.id)       //close modal
    //   this.forceRerender() //refresh the list of networks
    // },
    // editCancelled(){
    //   //close modal
    //   this.$root.$emit('bv::hide::modal', this.editModal.id)
    // },
    // addNew(button) {
    //   this.newModal.title = `Add Network`
    //   this.newModal.content = 'Please enter the details'
    //   this.$root.$emit('bv::show::modal', this.newModal.id, button)
    // },
    // resetNewModal() {
    //   this.newModal.title = ''
    //   this.newModal.content = ''
    // },
    // newComplete(){
    //   this.$root.$emit('bv::hide::modal', this.newModal.id)       //close modal
    //   this.forceRerender() //refresh the list of networks
    // },
    // newCancelled(){
    //   //close modal
    //   this.$root.$emit('bv::hide::modal', this.newModal.id)
    // },
    // deleteNetwork(item, index, button) {
    //   this.deleteModal.title = `Confirm Network Deletion: ${item.name.S}`
    //   this.selectedNetwork=item
    //   this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
    // },
    // resetDeleteModal() {
    //   this.deleteModal.title = ''
    //   this.deleteModal.content = ''
    // },
    // deleteComplete(){
    //   this.$root.$emit('bv::hide::modal', this.deleteModal.id)       //close modal
    //   this.forceRerender() //refresh the list of networks
    // },
    // deleteCancelled(){
    //   //close modal
    //   this.$root.$emit('bv::hide::modal', this.deleteModal.id)
    // },
    // forceRerender() { //forces the table to reload with updated info from backend
    //   this.componentKey += 1;  
    //   //this.getAllNetworks()
    // },
    // getAllNetworks() {
    //   this.isBusy = true
    //   let promise = IPManService.getAllNetworks()
    //   return promise.then((data) => {
    //     this.items = data.Items
    //     console.log(this.items)
    //     // Here we could override the busy state, setting isBusy to false
    //     this.isBusy = false
    //     this.forceRerender()
    //     // this.items=items
    //    this.totalRows = this.items.length
    //     //return(this.items)
    //   }).catch(error => {
    //     // Here we could override the busy state, setting isBusy to false
    //     this.items=[]
    //     this.isBusy = false
    //     this.forceRerender()
    //     // Returning an empty array, allows table to correctly handle
    //     // internal busy state in case of error
    //     this.totalRows = this.items.length
    //     //return []
    //     //return(this.items)

    //   })        
    // },
    // getNetwork() {
    //   IPManService.getNetwork('guid').then((data) => {
    //     console.log('Network')
    //     console.log(data)
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    //   return null
    // },
    // onNetworkSelected(items) {
    //   console.log(items[0])
    //   this.$router.push({
    //     name: 'browse',
    //     params:{network: items[0]}
    //     })
    // },
  }
}
</script>